<template>
  <div class="finalize-logo-container" :style="BackgroundColor">
    <div class="justify-content-center text-center">
      <div class="big-logo">
        <img :src="Logo" @error="imgHttpError" />
      </div>
      <div style="margin-top: 10%">
        <h3 style="font-size: 20px">{{ $t("message.finalizeSoCompleteTitle") }}</h3>
        <p
          style="
            padding-top: 30px;
            width: 460px;
            margin-left: auto;
            margin-right: auto;
            font-size: 16px;
          "
        >
          {{ $t("message.finalizeSoCompleteMessage") }}
        </p>
      </div>
      <div
        class="d-flex"
        style="
          width: 600px;
          margin-left: auto;
          margin-right: auto;
          margin-top: 50px;
        "
      >
        <AppleWallet class="col-4" v-if="isIos" :user-id="userId" :store-id="storeid" />
        <GooglWallet
          v-if="!isIos && false"
          @update-status="(u) => updateStatus(u)"
          class="col-4"
          :user-id="userId"
          :store-name="storename"
        />
        <button
          type="button"
          :style="desktopStyles.btn"
          class="btn btn-primery col-8 download"
          @click="saveAsImage()"
        >
          {{ $t("message.DownloadAsImage") }}
        </button>
      </div>
      <div class="logo-powered-by">Powered by</div>
      <div class="abacus-logo"></div>
    </div>
    <progressindicator
      v-if="showProgress"
      style="opacity: 0.4"
    ></progressindicator>
  </div>
</template>

<script>
import GooglWallet from "./partials/googleWallet.vue";
import AppleWallet from "./partials/appleWallet.vue";
import progressindicator from "../progressindicator";
import { wcconfig } from "../../../wcConfig";
import { mapGetters } from "vuex";
import QRCode from "qrcode";
export default {
  components: {
    GooglWallet,
    progressindicator,
    AppleWallet,
  },
  props: {
    storeid: {
      type: String,
      default: null,
    },
    userId: {
      type: String,
      default: null,
    },
    storename: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      qrCodeHref: null,
      logoUrl: "",
      showProgress: false,
    };
  },
  created() {
    this.logoUrl = wcconfig.assets.abacus;
  },
  computed: {
    ...mapGetters(["desktopStyles", "viewConfig", "currentStoreDoc"]),
    isIos() {
      var isIos = !!navigator.platform.match(/iPhone|iPod|iPad/) || !!navigator.platform.match(/Mac68K|MacPPC|MacIntel/);
      return isIos;
    },
    Logo() {
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.BackgroundPhotos
      ) {
        return this.currentStoreDoc.ThemeSettings.BackgroundPhotos.CommonLogo;
      }
      return "";
    },
    BackgroundColor() {
      var styles = [];
      var colour = "#3994ff";
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.Colours &&
        this.currentStoreDoc.ThemeSettings.Colours.IntroBackground
      ) {
        colour = this.currentStoreDoc.ThemeSettings.Colours.IntroBackground;
      }
      styles.push({ "background-color": `${colour}` });
      return styles;
    },
    ...mapGetters(["desktopStyles"]),
  },
  async mounted() {
    var a = document.getElementById("qrCodeContainer");
    await QRCode.toCanvas(a, ";" + this.userId);
  },
  methods: {
    async saveAsImage() {
      var dataUrl = await QRCode.toDataURL(";" + this.userId);
      var a = document.createElement("a");
      a.download = "QrCode.png";
      a.href = dataUrl;
      a.click();
    },
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
    updateStatus(status) {
      if (!status) {
        setTimeout(() => {
          this.showProgress = status;
        }, 1000);
      } else this.showProgress = status;
    },
  },
};
</script>

<style lang="scss">
.finalize-logo-container {
  min-height: 100vh;
  background: #3994ff 0% 0% no-repeat padding-box;
  opacity: 0.95;
  color: #ffffff;
  .step-title {
    font-size: 20px;
    font-weight: 600;
    color: #ffffff;
    padding-top: 50px;
    margin-left: 40%;
  }

  .step-desc {
    width: 50%;
    font-size: 16px;
    color: #ffffff;
    margin-top: 30px;
    margin-left: 40%;
  }

  .logo-powered-by {
    margin-left: auto;
    margin-right: auto;
    width: 82px;
    font-size: 10px;
    color: #ffffff;
    margin-top: 138px;
  }

  .download {
    color: #ffffff !important;
    border-radius: 3px;
    margin: 0px auto;
    height: 38px;
  }

  .abacus-logo {
    margin-left: auto;
    margin-right: auto;
    height: 26px;
    width: 100px;
    background: transparent url("./../../assets/abacus-logo-white.png") 0% 0%
      no-repeat padding-box;
    opacity: 1;
    background-size: contain;
  }
}

.big-logo {
  margin-top: 0;
  padding-top: 10%;
  margin-left: 0;
  max-height: 158px;
  max-width: 159px;
  margin-left: auto;
  margin-right: auto;
  img {
    max-height: 100%;
    max-width: 100%;
  }
}

.oo-module {
  .form-container {
    padding: 20px 0;
    width: 440px;
    background-color: #ffffff;
    margin-top: 10%;
    margin-bottom: 3%;

    .form-group {
      width: 374px;
      margin-bottom: 0.2rem;
      .checkbox-label {
        left: 0;
      }
      span.checkbox-checkmark {
        left: 0px !important;
      }
      p.agree-container {
        position: relative;
        left: -20px;
        text-align: left;
        font-size: 0.6875rem;
        line-height: 1.4;
        text-align: left;
      }
      label {
        font-size: 0.8rem;
        margin-bottom: 0.1rem;
      }

      .form-control,
      .dropdown-toggle {
        border-radius: 0px;
      }
    }
  }
}
</style>
